import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressBarModule } from 'primeng/progressbar';
import { BookingComponent } from './booking/booking.component';
import { HomeComponent } from './home/home.component';
import { ResourceComponent } from './resource/resource.component';
import { RestrictionComponent } from './restriction/restriction.component';
import { ClassComponent } from './class/class.component';
import { PackageruleComponent } from './packagerule/packagerule.component';
import { TableModule } from 'primeng/table';
import { RestrictioneditComponent } from './restriction/restrictionedit.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastModule} from 'primeng/toast';
import { MessageModule } from 'primeng/message';
import { MessageService } from 'primeng/api';
import { VenueclosingsComponent } from './venueclosings/venueclosings.component';
import { VenueclosingsEditComponent } from './venueclosings/venueclosingsedit.component';
import { MenuModule } from 'primeng/menu';
import { CalendarModule } from 'primeng/calendar';
import { ClasseditComponent } from './class/classedit.component';
import { PackageruleeditComponent } from './packagerule/packageruleedit.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ResourceeditComponent } from './resource/resourceedit.component';
import { AtaglanceComponent } from './ataglance/ataglance.component';
import { AccordionModule } from 'primeng/accordion';
import { MakeabookingComponent } from './makeabooking/makeabooking.component';
import { GetQuantityOptionsPipe } from './makeabooking/get-quantity-options.pipe';
import { tagComponent } from './tag/tag.component';
import { TageditComponent } from './tag/tagedit.component';
import { extraComponent } from './extra/extra.component';
import { ExtraeditComponent } from './extra/extraedit.component';
import { TagModule } from 'primeng/tag';
import { ChipModule } from 'primeng/chip';
import { MultiSelectModule } from 'primeng/multiselect';
import { extraoptionsComponent } from './extraoption/extraoption.component';
import { ExtraOptioneditComponent } from './extraoption/extraoptionedit.component';
import { PackageeditComponent } from './package/packageedit.component';
import { packageComponent } from './package/package.component';
import { TabViewModule } from 'primeng/tabview';
import { VenuesettingsComponent } from './venuesettings/venuesettings.component';
import { GMapModule } from 'primeng/gmap';
import { AdmissionsComponent } from './admissions/admissions.component';
import { AdmissioneditComponent } from './admissions/admissionedit.component';
import { SliderModule } from 'primeng/slider';
import { PackagestarttimesComponent } from './packagestarttimes/packagestarttimes.component';
import { TimesetsComponent } from './timesets/timesets.component';
import { TimeseteditComponent } from './timesets/timesetedit.component';
import {StepsModule} from 'primeng/steps';
import {BadgeModule} from 'primeng/badge';
import { PackageextrasComponent } from './packageextras/packageextras.component';
import { MultipackageextrasComponent } from './multipackageextras/multipackageextras.component';
import { EditseriesComponent } from './editseries/editseries.component';
import {DialogModule} from 'primeng/dialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {ConfirmationService} from 'primeng/api';
import {ChartModule} from 'primeng/chart';
import { FullCalendarModule } from '@fullcalendar/angular';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {RadioButtonModule} from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TimesetviewComponent } from './timesets/timesetview.component';
import { DepositpoliciesComponent } from './depositpolicies/depositpolicies.component';
import { DepositpolicieseditComponent } from './depositpolicies/depositpoliciesedit.component';
import { EditbookingComponent } from './editbooking/editbooking.component';
import { PaymentTestComponent } from './payment-test/payment-test.component';
import { StaffloginComponent } from './stafflogin/stafflogin.component';
import { BookingcalendarComponent } from './bookingcalendar/bookingcalendar.component';
import { TillComponent } from './till/till.component';
import { TilldepartmentsComponent } from './tilldepartments/tilldepartments.component';
import { TillproductsComponent } from './tillproducts/tillproducts.component';
import { TilldepartmentseditComponent } from './tilldepartments/tilldepartmentsedit.component';
import { TillproductseditComponent } from './tillproducts/tillproductsedit.component';
import { ResourcegroupnameeditComponent } from './resourcegroupname/resourcegroupnameedit.component';
import { ResourcegroupnameComponent } from './resourcegroupname/resourcegroupname.component';
import { BookingfeeComponent } from './bookingfee/bookingfee.component';
import { BookingfeeeditComponent } from './bookingfee/bookingfeeedit.component';
import { BookingfeelistComponent } from './bookingfee/bookingfeelist.component';
import { PackagebookingfeesComponent } from './bookingfee/packagebookingfees.component';
import { AuthModule } from '@auth0/auth0-angular';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { environment as env } from '../environments/environment';
import { TermsandconditionsComponent } from './termsandconditions/termsandconditions.component';
import { EditorModule } from 'primeng/editor';
import { BusinessComponent } from './business/business.component';
import { GlobalService } from './_services/global.service';
import { PinpadComponent } from './pinpad/pinpad.component';
import { SmartAuthInterceptorInterceptor } from './_interceptors/smart-auth-interceptor.interceptor';
import { ReportsComponent } from './reports/backup-report-stuff/reports.component';
import { CashupComponent } from './cashup/cashup.component';
import { SummaryComponent } from './summary/summary.component';
import { CardModule } from 'primeng/card';
import { DiscountsEditComponent } from './discounts/discountsedit.component';
import { ConfirmationeditorComponent } from './confirmationeditor/confirmationeditor.component';
import { PackagegroupsComponent } from './packagegroups/packagegroups.component';
import { DiscountsComponent } from './discounts/discounts.component';
import { PackagegroupeditComponent } from './packagegroups/packagegroupedit.component';
import { ConfirmationComponent } from './confirmationeditor/confirmation.component';
import { ImageuploadtestComponent } from './imageuploadtest/imageuploadtest.component';
import { FileUploadModule } from 'primeng/fileupload';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { UsersComponent } from './users/users.component';
import { UsereditComponent } from './users/useredit.component';
import { SafePipe } from './safe.pipe';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PublictermsandconditionsComponent } from './publictermsandconditions/publictermsandconditions.component';
import { DaysheetStyle1Component } from './daysheetStyle1/daysheetStyle1.component';
import { PrintconfirmationComponent } from './printconfirmation/printconfirmation.component';
import { SearchComponent } from './search/search.component';
import { BookingquestionsComponent } from './bookingquestions/bookingquestions.component';
import { BookingquestioneditComponent } from './bookingquestions/bookingquestionedit.component';
import { BookingquestionnaireComponent } from './bookingquestionnaire/bookingquestionnaire.component';
import { BookingquestionnaireeditComponent } from './bookingquestionnaire/bookingquestionnaireedit.component';
import { ResourceclosingsComponent } from './resourceclosings/resourceclosings.component';
import { ResourceclosingseditComponent } from './resourceclosings/resourceclosingsedit.component';
import { CashuplistComponent } from './cashup/cashuplist.component';
import { EventsComponent } from './events/events.component';
import { EventeditComponent } from './events/eventedit.component';
import { ResourceadjustmentsComponent } from './resourceadjustments/resourceadjustments.component';
import { ResourceadjustmenteditComponent } from './resourceadjustments/resourceadjustmentedit.component';
import { EmailtemplateComponent } from './emailtemplate/emailtemplate.component';
import { EmailtemplateeditComponent } from './emailtemplate/emailtemplateedit.component';
import { DragDropModule } from 'primeng/dragdrop'
import { BookingblockComponent } from './bookingblock/bookingblock.component';
import { CounterslistComponent } from './counterslist/counterslist.component';
import { VoucherlistComponent } from './voucherlist/voucherlist.component';
import { TasktypelistComponent } from './tasktype/tasktypelist.component';
import { BuyvoucherComponent } from './buyvoucher/buyvoucher.component';
import { VouchereditComponent } from './voucherlist/voucheredit.component';
import { TasktypeeditComponent } from './tasktype/tasktypeedit.component'
import { StyleClassModule } from 'primeng/styleclass';
import { CreatenewcustomerComponent } from './createnewbusinessuser/createnewcustomer.component';
import { CreatenewbusinessuserComponent } from './createnewbusinessuser/createnewbusinessuser.component';
import { CreatenewmasterkeyuserComponent } from './createnewbusinessuser/createnewmasterkeyuser.component';
import { AddnewvenuetobusinessComponent } from './createnewbusinessuser/addnewvenuetobusiness.component';
import { ExtrasreportComponent } from './reports/extrasreport/extrasreport.component';
import { QrcodeComponent } from './qrcode/qrcode.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { BookinganswersreportComponent } from './reports/bookinganswersreport/bookinganswersreport.component';
import { MarketingComponent } from './marketing/marketing.component';
import { MarketingbirthdayComponent } from './marketing/marketingbirthday/marketingbirthday.component';
import { MarketingabandonedComponent } from './marketing/marketingabandoned/marketingabandoned.component';
import { MarketingmissingComponent } from './marketing/marketingmissing/marketingmissing.component';
import { MarketinggroupComponent } from './marketing/marketinggroup/marketinggroup.component';
import { MarketingbirthdayeditComponent } from './marketing/marketingbirthday/marketingbirthdayedit.component';
import { MarketingemailsComponent } from './marketing/marketingemails/marketingemails.component';
import { MarketingrevenueComponent } from './marketing/marketingrevenue/marketingrevenue.component';
import { WarningsComponent } from './warnings/warnings.component';
import { WarningeditComponent } from './warnings/warningedit.component';
import { TestingtasklistComponent } from './testingtasklist/testingtasklist.component';
import { BuycreditsComponent } from './buycredits/buycredits.component';
import { LinkmanagerComponent } from './linkmanager/linkmanager.component';
import { LinkeditorComponent } from './linkmanager/linkeditor.component';
import { ClipboardModule } from 'ngx-clipboard';
import { BookinglistComponent } from './bookinglist/bookinglist.component';
import { PartylistComponent } from './partylist/partylist.component';
import { PartybookingComponent } from './partybooking/partybooking.component';
import { BookingstoacknowledgeComponent } from './bookingstoacknowledge/bookingstoacknowledge.component';
import { PaymentreportComponent } from './reports/paymentreport/paymentreport.component';
import { ReportpageComponent } from './reports/reportpage/reportpage.component';
import { CustomerreportComponent } from './reports/customerreport/customerreport.component';
import { BookinglistreportComponent } from './reports/bookinglistreport/bookinglistreport.component';
import { BookinglistcreatedreportComponent } from './reports/bookinglistcreatedreport/bookinglistcreatedreport.component';
import { SalesreportComponent } from './reports/salesreport/salesreport.component';
import { MembershiptypesComponent } from './membershiptypes/membershiptypes.component';
import { MembershipsComponent } from './memberships/memberships.component';
import { MembershiptypeeditComponent } from './membershiptypes/membershiptypeedit.component';
import { AlternativefrontpageComponent } from './alternativefrontpage/alternativefrontpage.component';
import { UpgradesComponent } from './upgrades/upgrades.component';
import { PackageupgradesComponent } from './packageupgrades/packageupgrades.component';
import { UpgradeeditComponent } from './upgrades/upgradeedit.component';
import { EditmembershipComponent } from './membershiplist/editmembership.component';
import { MembershiplistComponent } from './membershiplist/membershiplist.component';
import { ResclosingseditComponent } from './resourceclosings/resclosingsedit.component';
import { ResreductionseditComponent } from './resourceclosings/resreductionsedit.component';
import { ScheduledSessionsComponent } from './scheduledsession/scheduledsession.component';
import { ScheduledSessionregisterComponent } from './scheduledsessionregister/scheduledsessionregister.component';
import { ScheduledSessioncalendarComponent } from './scheduledsessioncalendar/scheduledsessioncalendar.component';
import { ScheduledSessioneditComponent } from './scheduledsession/scheduledsessionedit.component';
import { PrinttestComponent } from './printtest/printtest.component';
import { SchedeuledsessionlistComponent } from './scheduledsession/schedeuledsessionlist.component';
import { EditcustomerschedeuledsessionComponent } from './scheduledsession/editcustomerschedeuledsession.component';
import { PanelMenuModule } from 'primeng/panelmenu';
import { AdmissionbasedupgradesComponent } from './admissionbasedupgrades/admissionbasedupgrades.component';
import { AdmissionbasedupgradeseditComponent } from './admissionbasedupgrades/admissionbasedupgradesedit.component';
import { PackageaddonsComponent } from './packageaddons/packageaddons.component';
import { HomepagechoiceComponent } from './homepagechoice/homepagechoice.component';
import { StatementofriskComponent } from './statementofrisk/statementofrisk.component';
import { StatementofriskeditComponent } from './statementofrisk/statementofriskedit.component';
import { ManagewaiverComponent } from './managewaiver/managewaiver.component';
import { AgreementComponent } from './agreement/agreement.component';
import { IntegrationsComponent } from './integrations/integrations.component';
import { SimracingComponent } from './integrations/simracing.component';
import { BrevoComponent } from './integrations/brevo.component';
import { MailChimpComponent } from './integrations/mailchimp.component';
import { CustomerportalComponent } from './customerportal/customerportal.component';
import { KitchendisplaysystemComponent } from './till/kitchendisplaysystem/kitchendisplaysystem.component';
import { TillproductoptionsComponent } from './till/tillproductoptions/tillproductoptions.component';
import { TillproductoptionseditComponent } from './till/tillproductoptionsedit/tillproductoptionsedit.component';
import { TillproductoptionsassignComponent } from './till/tillproductoptionsassign/tillproductoptionsassign.component';
import { CounterbookinglistComponent } from './counterbookinglist/counterbookinglist.component';
import { AtaglancebookingsComponent } from './ataglancebookings/ataglancebookings.component';
import { TillsalemanagerComponent } from './tillsalemanager/tillsalemanager.component';

@NgModule({

  declarations: [
    AppComponent,
    BookingComponent,
    HomeComponent,
    ResourceComponent,
    RestrictionComponent,
    ClassComponent,
    PackageruleComponent,
    RestrictioneditComponent,
    VenueclosingsComponent,
    VenueclosingsEditComponent,
    ClasseditComponent,
    PackageruleeditComponent,
    ResourceeditComponent,
    AtaglanceComponent,
    MakeabookingComponent,
    GetQuantityOptionsPipe,
    tagComponent,
    TageditComponent,
    extraComponent,
    ExtraeditComponent,
    extraoptionsComponent,
    ExtraOptioneditComponent,
    packageComponent,
    PackageeditComponent,
    VenuesettingsComponent,
    AdmissionsComponent,
    AdmissioneditComponent,
    PackagestarttimesComponent,
    TimesetsComponent,
    TimeseteditComponent,
    PackageextrasComponent,
    MultipackageextrasComponent,
    EditseriesComponent,
    TimesetviewComponent,
    DepositpoliciesComponent,
    DepositpolicieseditComponent,
    EditbookingComponent,
    PaymentTestComponent,
    StaffloginComponent,
    BookingcalendarComponent,
    TillComponent,
    TilldepartmentsComponent,
    TillproductsComponent,
    TilldepartmentseditComponent,
    TillproductseditComponent,
    TillproductoptionsComponent,
    TillproductoptionseditComponent,
    TillproductoptionsassignComponent,
    ResourcegroupnameComponent,
    ResourcegroupnameeditComponent,
    BookingfeeComponent,
    BookingfeeeditComponent,
    BookingfeelistComponent,
    PackagebookingfeesComponent,
    TermsandconditionsComponent,
    BusinessComponent,
    PinpadComponent,
    ReportsComponent,
    CashupComponent,
    SummaryComponent,
    DiscountsEditComponent,
    ConfirmationeditorComponent,
    PackagegroupsComponent,
    DiscountsComponent,
    PackagegroupeditComponent,
    ConfirmationComponent,
    ImageuploadtestComponent,
    UsersComponent,
    UsereditComponent,
    SafePipe,
    PublictermsandconditionsComponent,
    DaysheetStyle1Component,
    PrintconfirmationComponent,
    SearchComponent,
    BookingquestionsComponent,
    BookingquestioneditComponent,
    BookingquestionnaireComponent,
    BookingquestionnaireeditComponent,
    ResourceclosingsComponent,
    ResourceclosingseditComponent,
    CashuplistComponent,
    EventsComponent,
    EventeditComponent,
    ResourceadjustmentsComponent,
    ResourceadjustmenteditComponent,
    EmailtemplateComponent,
    EmailtemplateeditComponent,
    BookingblockComponent,
    CounterslistComponent,
    VoucherlistComponent,
    TasktypelistComponent,
    BuyvoucherComponent,
    VouchereditComponent,
    TasktypeeditComponent,
    CreatenewcustomerComponent,
    CreatenewbusinessuserComponent,
    CreatenewmasterkeyuserComponent,
    AddnewvenuetobusinessComponent,
    ExtrasreportComponent,
    QrcodeComponent,
    BookinganswersreportComponent,
    MarketingComponent,
    MarketingbirthdayComponent,
    MarketingabandonedComponent,
    MarketingmissingComponent,
    MarketinggroupComponent,
    MarketingbirthdayeditComponent,
    MarketingemailsComponent,
    MarketingrevenueComponent,
    WarningsComponent,
    WarningeditComponent,
    TestingtasklistComponent,
    BuycreditsComponent,
    LinkmanagerComponent,
    LinkeditorComponent,
    BookinglistComponent,
    PartylistComponent,
    PartybookingComponent,
    BookingstoacknowledgeComponent,
    PaymentreportComponent,
    ReportpageComponent,
    CustomerreportComponent,
    BookinglistreportComponent,
    BookinglistcreatedreportComponent,
    SalesreportComponent,
    MembershiptypesComponent,
    MembershipsComponent,
    MembershiptypeeditComponent,
    AlternativefrontpageComponent,
    UpgradesComponent,
    PackageupgradesComponent,
    UpgradeeditComponent,
    EditmembershipComponent,
    MembershiplistComponent,
    ResclosingseditComponent,
    ResreductionseditComponent,
    ScheduledSessionsComponent,
    ScheduledSessionregisterComponent,
    ScheduledSessioncalendarComponent,
    ScheduledSessioneditComponent,
    PrinttestComponent,
    SchedeuledsessionlistComponent,
    EditcustomerschedeuledsessionComponent,
    AdmissionbasedupgradesComponent,
    AdmissionbasedupgradeseditComponent,
    PackageaddonsComponent,
    HomepagechoiceComponent,
    StatementofriskComponent,
    StatementofriskeditComponent,
    ManagewaiverComponent,
    AgreementComponent,
    IntegrationsComponent,
    SimracingComponent,
    BrevoComponent,
    MailChimpComponent,
    CustomerportalComponent,
    KitchendisplaysystemComponent,
    CounterbookinglistComponent,
    AtaglancebookingsComponent,
    TillsalemanagerComponent
  ],
  imports: [
    ClipboardModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    InputNumberModule,
    DropdownModule,
    FormsModule,
    ToggleButtonModule,
    TableModule,
    ButtonModule,
    CheckboxModule,
    ProgressBarModule,
    InputTextModule,
    InputTextareaModule,
    NgxSpinnerModule,
    ToastModule,
    MessageModule,
    MenuModule,
    CalendarModule,
    SelectButtonModule,
    ColorPickerModule,
    AccordionModule,
    DragDropModule,
    ChipModule,
    TagModule,
    TabViewModule,
    GMapModule,
    SliderModule,
    StepsModule,
    BadgeModule,
    DialogModule,
    ConfirmDialogModule,
    ChartModule,
    FullCalendarModule,
    DynamicDialogModule,
    RadioButtonModule,
    InputSwitchModule,
    EditorModule,
    CardModule,
    FileUploadModule,
    BreadcrumbModule,
    StyleClassModule,
    MultiSelectModule,
    OverlayPanelModule,
    PanelMenuModule,
    NgIdleKeepaliveModule.forRoot(),
    // Import the module into the application, with configuration
    AuthModule.forRoot({
      ...env.auth,
      httpInterceptor: {
        ...env.httpInterceptor,
      },
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SmartAuthInterceptorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    MessageService,
    ConfirmationService,
    GlobalService
    
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
